import { doMutation } from "../../core-module/util/graphqlHelper";

export const createTrainingRegistration = trainingRegistration => {
  const mutation = require("../api/mutation/createTrainingRegistration.gql");
  const variables = trainingRegistration;

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.createTrainingRegistration };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
